import { Checkbox, TableCell, TableRow } from "@material-ui/core";
import { CSSProperties, FC } from "react";
import { Formater } from "src/framework/commons";
import { ColumnDefinition } from "src/framework/store";

interface RowProperties {
  row: any;
  columnDefinitions: ColumnDefinition[];
  isGroupHeader: boolean;
  checkable?: boolean;
  lastGroupContent?: string;
  setLastGroupContent: (value?: string) => void;
  isChecked: boolean;
  onCheck?: <T = any>(row: T) => void;
}

const Row: FC<RowProperties> = ({
  row,
  columnDefinitions,
  isGroupHeader,
  setLastGroupContent,
  lastGroupContent,
  checkable = false,
  isChecked = false,
  onCheck,

}) => {
  return (
    <TableRow>
      {checkable ? (
        <TableCell padding="checkbox">
          <Checkbox
            checked={isChecked}
            onChange={() => {
              if (onCheck) {
                onCheck(row);
              }
            }}
          />
        </TableCell>
      ) : ""}

      {columnDefinitions.map((columnDef: ColumnDefinition, j: number) => {
        const key = `${row["id"]}-${columnDef["field"]}`;

        let style: CSSProperties = {};

        if (j !== 0 && isGroupHeader) {
          if (lastGroupContent && lastGroupContent !== columnDef.group) {
            style = {
              borderLeftStyle: "ridge",
              borderLeftColor: "rgba(224, 224, 224, 1)",
              borderLeftWidth: "1px",
            };
          }
        }

        setLastGroupContent(columnDef.group);

        if (columnDef.render) {
          const render = columnDef.render(row, style);

          return (
            <TableCell
              key={key}
              align={Formater.toAlign(columnDef?.type, columnDef?.align)}
              style={style}
            >
              {render}
            </TableCell>
          );
        }

        return (
          <TableCell key={key} style={style} align={Formater.toAlign(columnDef?.type, columnDef?.align)}>
            {columnDef.type
              ? Formater.toString(row[columnDef.field], columnDef?.type)
              : row[columnDef.field]}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export { Row };
